/* Demo gratuit: încarci o fotografie, serviciul nostru o restaurează și întoarce DOAR
   varianta cu filigran. „Înainte” este fotografia din browserul tău; „După” vine de la
   server, cu filigranul ars în imagine (nu este pus din CSS). */
(function () {
  'use strict';

  var STORE_KEY = 'rf_demo_v1';

  function init(box) {
    if (box.hasAttribute('data-rf-bound')) return;
    box.setAttribute('data-rf-bound', '');

    var states = box.querySelectorAll('[data-rf-demo-state]');
    var input = box.querySelector('[data-rf-demo-input]');
    var preview = box.querySelector('[data-rf-demo-preview]');
    var status = box.querySelector('[data-rf-demo-status]');
    var result = box.querySelector('[data-rf-demo-result]');
    var buy = box.querySelector('[data-rf-demo-buy]');
    var again = box.querySelector('[data-rf-demo-again]');
    var errorText = box.querySelector('[data-rf-demo-error]');
    var defaultError = errorText ? errorText.textContent : '';
    var messages = (box.getAttribute('data-t-processing') || '').split('|').filter(Boolean);
    var ticker = 0, current = null;

    function show(name) {
      states.forEach(function (s) { s.hidden = s.getAttribute('data-rf-demo-state') !== name; });
      clearInterval(ticker);
      if (name === 'working' && messages.length > 1) {
        var i = 0;
        ticker = setInterval(function () { i = (i + 1) % messages.length; status.textContent = messages[i]; }, 3200);
      }
    }

    function showResult(demo) {
      current = demo;
      var before = box.getAttribute('data-t-before') || 'Înainte';
      var after = box.getAttribute('data-t-after') || 'După';
      result.innerHTML =
        '<div class="rf-compare" data-rf-compare style="--rf-ar: ' + demo.width + ' / ' + demo.height + '; --rf-pos: 50%;">' +
        '<div class="rf-compare__layer rf-compare__layer--after"><img alt=""></div>' +
        '<div class="rf-compare__layer rf-compare__layer--before"><img alt=""></div>' +
        '<span class="rf-compare__label rf-compare__label--before"></span><span class="rf-compare__label rf-compare__label--after"></span>' +
        '<div class="rf-compare__handle" aria-hidden="true"><span class="rf-compare__knob"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l-5 6 5 6M15 6l5 6-5 6"/></svg></span></div>' +
        '<input class="rf-compare__range" type="range" min="0" max="100" value="50" aria-label="' + before + ' / ' + after + '"></div>';
      var imgs = result.querySelectorAll('img'), labels = result.querySelectorAll('.rf-compare__label');
      imgs[0].src = demo.after; imgs[1].src = demo.before;
      labels[0].textContent = before; labels[1].textContent = after;
      RF.compare.init(result.querySelector('[data-rf-compare]'));
      if (again) again.hidden = !(demo.remaining > 0);
      show('done');
    }

    function fail(err) {
      if (err && (err.status === 429 || err.code === 'limit')) return show('limit');
      if (errorText) {
        errorText.textContent = err && err.message === 'decode' ? (box.getAttribute('data-t-decode') || defaultError)
          : err && err.code === 'no-api' ? (box.getAttribute('data-t-noapi') || defaultError)
          : defaultError;
      }
      show('error');
    }

    function run(file) {
      var local;
      RF.track('demo_upload', {});
      RF.shrinkImage(file, 2000, 0.9).then(function (img) {
        local = img;
        preview.src = RF.thumb(img.canvas, 600);
        if (messages.length) status.textContent = messages[0];
        show('working');
        return RF.api('/api/demo', {
          method: 'POST',
          headers: { 'Content-Type': 'image/jpeg', 'X-Visitor': RF.uid() },
          body: img.blob
        });
      }).then(function (res) {
        var demo = { id: res.id, after: res.url, before: RF.thumb(local.canvas, 1200), thumb: RF.thumb(local.canvas, 420),
                     width: res.width || local.width, height: res.height || local.height, remaining: res.remaining, expires: res.expires };
        RF.store.set(STORE_KEY, demo);
        RF.track('demo_generated', { remaining: res.remaining });
        showResult(demo);
      }).catch(fail);
    }

    input.addEventListener('change', function () {
      if (input.files && input.files[0]) run(input.files[0]);
      input.value = '';
    });
    var drop = input.closest('.rf-drop');
    if (drop) {
      drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
      drop.addEventListener('drop', function (e) {
        e.preventDefault(); drop.classList.remove('is-over');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) run(file);
      });
    }

    if (buy) buy.addEventListener('click', function (e) {
      e.preventDefault();
      RF.track('demo_buy_click', {});
      if (current) document.dispatchEvent(new CustomEvent('rf:demo-buy', { detail: { id: current.id, thumb: current.thumb } }));
      RF.scrollTo(document.querySelector(buy.getAttribute('href')));
    });
    if (again) again.addEventListener('click', function () { show('idle'); });
    var retry = box.querySelector('[data-rf-demo-retry]');
    if (retry) retry.addEventListener('click', function () { show('idle'); });

    // rezultatul rămâne pe pagină dacă omul revine, cât timp adresa semnată e valabilă
    var saved = RF.store.get(STORE_KEY, null);
    if (saved && saved.expires && saved.expires > Date.now() + 60000) showResult(saved);
    else if (saved) RF.store.del(STORE_KEY);
  }

  RF.register(function (root) { root.querySelectorAll('[data-rf-demo]').forEach(init); });
})();
